import React from 'react';

const Vue_HTTP_Request = () => {
  return (
    <div>
      <h1>Vue_HTTP_Request Component</h1>
      <p>This is the Vue_HTTP_Request tutorial page.</p>
    </div>
  );
}

export default Vue_HTTP_Request;
